import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.622 4.31a2 2 0 0 1 2.17-1.642l.147.02 6.894 1.216a2 2 0 0 1 1.643 2.169l-.02.148-1.386 7.853 7.494-2.728a2 2 0 0 1 2.504 1.05l.059.146 2.394 6.577a2 2 0 0 1-.02 1.42L28.5 26a2 2 0 0 1-1.85 1.995L26.5 28H9q-.427 0-.85-.066c-2.963-.464-4.99-3.29-4.585-6.26l.034-.217zM26.5 21.985 15.464 26H26.5zm-20.93-.18L8.592 4.659l6.894 1.216-3.04 17.234-.037.185a3.5 3.5 0 0 1-3.95 2.665c-1.917-.3-3.235-2.198-2.89-4.153m18.679-8.578-8.58 3.122-1.251 7.107q-.082.458-.232.883l12.457-4.535zM10.5 22.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSelections = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSelections);
export default Memo;
